
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";

import Routers from "./Route";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import CustomizerProvider from "./_helper/Customizer/CustomizerProvider";
import "./axios/global";

import "react-toastify/dist/ReactToastify.css";
import AuthProvider from "./_helper/auth/AuthProvider";


const App = () => {

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
        onError: (error) => {
          if (error.response) {
            const status = error.response.status;
       
            switch (status) {
              case 400:
                return error.response.data.message;
                break;
              case 401:
                
            localStorage.clear()
            window.location.href=`${process.env.PUBLIC_URL}/login`
                break;
              case 403:
                return error.response.data.message;
                break;
              case 404:
                return error.response.data.message;
                break;
              case 500:
                return error.response.data.error;
                break;
              default:
                return error.response.data.message;
                break;
            }
          }
        },
      },
    },
  });

  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
        <CustomizerProvider>
          <AnimationThemeProvider>
            <Routers />
            <ToastContainer />
          
          </AnimationThemeProvider>
        </CustomizerProvider>
        </AuthProvider>
      </QueryClientProvider>
    </div>
  );
};

export default App;
